var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star",style:({'margin-top': _vm.properties.topMargin + 'px', 'margin-left': _vm.properties.leftMargin + 'px'})},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('span',[_vm._v(".")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }